/*
 * @Author: your name
 * @Date: 2020-11-25 13:11:39
 * @LastEditTime: 2020-11-25 14:02:09
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ufun-new-bc/src/store/middleware/local.js
 */
import { LOCAL_CONST_NAME } from '@/constant/index';
import chalk from '@/util/chalk';

export default function localer({ getState }) {
    return next => action => {
        let newState = next(action)
        try {
            localStorage.setItem(LOCAL_CONST_NAME, JSON.stringify(getState()));
            // console.log(chalk.redux('写入本地成功'))
        } catch (error) {
            console.log(chalk.red('写入本地异常'),error) 
        }
        return newState
    }
}